import type { RaffleStage } from './types';

export const WIDGET_SAFE_ID_PREFIX = 'widget_id_';

export const POPUP_ANIMATIOM_DURATION_SECS = 0.3;

export const BENEFIT_TYPES = [
  'offer',
  'gift',
  'wheelOfFortune',
  'message',
  'personalGift',
  '2-3-offer',
  'quest',
  'rollingOffer',
  'road',
  'action',
];

export const RAFFLE_STAGE_TO_EVENT_NAME = {
  announcement: 'raffle_announcement',
  entry: 'raffle_entry_popup',
  winner: 'raffle_winners',
  loser: 'raffle_losers',
} as const satisfies Record<RaffleStage, string>;

export const GRANTED_EXTRA_OFFER_OPEN_WINDOW_MS = 60_000;
